import React from 'react';
import { 
  Card, 
  CardContent, 
  CardHeader, 
  Typography, 
  Grid,
  Divider
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { 
  Person,
  Phone,
  LocationOn,
  Today,
  AttachMoney,
  Description,
  History
} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    marginBottom: theme.spacing(3)
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  detailItem: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  icon: {
    marginRight: theme.spacing(2),
    color: theme.palette.primary.main
  },
  label: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5)
  },
  value: {
    fontWeight: 500
  },
  divider: {
    margin: theme.spacing(2, 0)
  }
}));

export default function ApplicantDetails({ data }) {
  const classes = useStyles();

  const details = [
    {
      icon: <Person />,
      label: 'Applicant Name',
      value: data?.name || 'N/A'
    },
    {
      icon: <LocationOn />,
      label: 'Location',
      value: data?.location ? 
        (typeof data.location === 'object' && data.location.lat && data.location.lng ? 
          `${data.location.lat.toFixed(6)}, ${data.location.lng.toFixed(6)}` : 
          String(data.location)) : 
        'N/A'
    },
    {
      icon: <Phone />,
      label: 'Contact Number',
      value: data?.phone || 'N/A'
    },
    {
      icon: <Today />,
      label: 'Application Date',
      value: data?.applicationDate || 'N/A'
    },
    {
      icon: <AttachMoney />,
      label: 'Requested Amount',
      value: data?.requestedAmount || 'N/A'
    },
    {
      icon: <Description />,
      label: 'Loan Purpose',
      value: data?.loanPurpose || 'N/A'
    },
    {
      icon: <History />,
      label: 'Previous Loans',
      value: data?.previousLoans || '0'
    }
  ];

  return (
    <Card className={classes.card}>
      <CardHeader
        title="Loan Applicant Details"
        className={classes.cardHeader}
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Farm Information
            </Typography>
            <div className={classes.detailItem}>
              <Typography variant="body1">
                Crop Type: <strong>{data?.crop || 'N/A'}</strong>
              </Typography>
            </div>
            <div className={classes.detailItem}>
              <Typography variant="body1">
                Land Size: <strong>{data?.landSize || 'N/A'}</strong>
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12}>
            <Divider className={classes.divider} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Application Details
            </Typography>
            {details.map((detail, index) => (
              <div key={index} className={classes.detailItem}>
                <div className={classes.icon}>
                  {detail.icon}
                </div>
                <div>
                  <Typography variant="body2" className={classes.label}>
                    {detail.label}
                  </Typography>
                  <Typography variant="body1" className={classes.value}>
                    {detail.value}
                  </Typography>
                </div>
              </div>
            ))}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
